import React from 'react';
import useAutosize from 'hooks/useAutosize';

const AskTheExpertMessageInput = ({
  value,
  disabled,
  onChange,
  lessonTitle,
}) => {
  const autoSize = useAutosize();
  return (
    <textarea
      className="ExpertForm-message"
      placeholder={t('expert.learner.placeholder', { title: lessonTitle })}
      value={value}
      onChange={e => onChange(e.target.value)}
      disabled={disabled}
      ref={node => {
        if (node) {
          node.focus();
          autoSize(node);
        }
      }}
      onFocus={e => {
        const { value: temp } = e.target;
        e.target.value = '';
        e.target.value = temp;
      }}
    />
  );
};

export default AskTheExpertMessageInput;
